import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Temp from "../components/Temp";

export default withRouter(connect()(Temp));
